import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { UIDrawerModal } from '../components/modals';
import { UIIconBtn } from '../components/basic';
import { useLang } from '../../_LangContext';
import { useNavigation } from '../../_NavigationContext';
import { 
	TabBarItems, 
	MenuScreenExhibits, 
	MenuScreenSettings, 
	MenuScreenAbout, 
	createTabItems, 
	handleTabBarClick, 
	syncPageFromURL 
} from '../menu';

const ModalMenu = ({ isOpen, onClose, onPinClick, onInfoClick, onARClick }) =>
{
	const { lang } = useLang();
	const location = useLocation();
	const { navigateSetParam, navigateToHomeDirect } = useNavigation();

	const handleHomeClick = () =>
	{
		navigateToHomeDirect();
	};

	const [activePageID, setActivePageID] = useState(1);

	const tabItems = useMemo(() => createTabItems(), []);

	// Handle page parameter synchronization
	useEffect(() =>
	{
		syncPageFromURL(location, isOpen, activePageID, setActivePageID);
	},
	// eslint-disable-next-line react-hooks/exhaustive-deps
	[location.search, isOpen]); // Remove activePageID from dependencies

	const handleTabBarClickCallback = useCallback((id) =>
	{
		handleTabBarClick(id, lang, navigateSetParam, setActivePageID, tabItems);
	},
	[lang, navigateSetParam, tabItems]);

	return (
		<UIDrawerModal className='menu' isOpen={isOpen} onClose={onClose} shouldCloseOnOverlayClick={false}>
			<div className="modal-header-bar">
				<div className="left-ui">
					<div className="modal-bar-btn back" onClick={onClose}>
						<p className="icon angle-left" />
					</div>
				</div>
				<div className="right-ui sp-only">
					<UIIconBtn id="btn-map-home" className={`btn-map-home circle no-base`} btnKey="home" iconClass="home" onClick={handleHomeClick} />
				</div>
				<TabBarItems 
					className="pc-only" 
					items={tabItems} 
					onClick={handleTabBarClickCallback} 
					activePageID={activePageID} 
				/>
			</div>

			<div className="modal-container">
				{activePageID === 1 && (<MenuScreenExhibits lang={lang} onPinClick={onPinClick} onInfoClick={onInfoClick} onARClick={onARClick} />)}
				{activePageID === 2 && (<MenuScreenSettings lang={lang} />)}
				{activePageID === 3 && (<MenuScreenAbout lang={lang} />)}
			</div>

			<div className="modal-footer-bar sp-only">
				<TabBarItems 
					items={tabItems} 
					onClick={handleTabBarClickCallback} 
					activePageID={activePageID} 
				/>
			</div>
		</UIDrawerModal>
	);
};

export default ModalMenu;
